import React from 'react'
import { NavLink } from "react-router-dom"

const ErrorPage = () => {
  return (
    <div className='container container--welcome'>
        <div className='row--welcome alignfull container--search'>
        <div className='row'> 
          <div>           
              <h4 className="pt-3">Oops! </h4>
              <p className="text-medium-emphasis float-start">
                The page you are looking for was not found.
              </p>
              </div>
              <div>     
              Return to the <NavLink to="/"> Homepage </NavLink>
              </div>
            
          </div>
        </div>
      </div>
  )
}

export default ErrorPage
